import { useContext } from 'react';

import { context } from 'applications/GSP/pages/ParentHelper/providers/DialogProvider/context';

export const useDialogContext = () => useContext(context);
